import { render, staticRenderFns } from "./ModalCreate.vue?vue&type=template&id=a94536c8"
import script from "./ModalCreate.vue?vue&type=script&lang=js"
export * from "./ModalCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports